// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { Player, PlayerT } from '../tbs/player.js';


export class AddPlayerAction implements flatbuffers.IUnpackableObject<AddPlayerActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):AddPlayerAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsAddPlayerAction(bb:flatbuffers.ByteBuffer, obj?:AddPlayerAction):AddPlayerAction {
  return (obj || new AddPlayerAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsAddPlayerAction(bb:flatbuffers.ByteBuffer, obj?:AddPlayerAction):AddPlayerAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new AddPlayerAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapAddPlayer;
}

player(obj?:Player):Player|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new Player()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startAddPlayerAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapAddPlayer);
}

static addPlayer(builder:flatbuffers.Builder, playerOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, playerOffset, 0);
}

static endAddPlayerAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): AddPlayerActionT {
  return new AddPlayerActionT(
    this.type(),
    (this.player() !== null ? this.player()!.unpack() : null)
  );
}


unpackTo(_o: AddPlayerActionT): void {
  _o.type = this.type();
  _o.player = (this.player() !== null ? this.player()!.unpack() : null);
}
}

export class AddPlayerActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapAddPlayer,
  public player: PlayerT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const player = (this.player !== null ? this.player!.pack(builder) : 0);

  AddPlayerAction.startAddPlayerAction(builder);
  AddPlayerAction.addType(builder, this.type);
  AddPlayerAction.addPlayer(builder, player);

  return AddPlayerAction.endAddPlayerAction(builder);
}
}
